module.exports = __webpack_public_path__ + "img/feeder_logo.fed1a257.svg";